import { useContext, useState } from 'react';

import AddElementsModal from '@atom/components/common/addElementsModal/AddElementsModal';
import SubItemsContext from '@atom/components/common/subItemTree/SubItemsContext';
import { Icon, IconButton } from '@atom/mui';
import { AddIcon } from '@atom/mui/icons';

import classes from './subItemsTab.module.css';

const SubItemsHeader = () => {
  const { rootAsset, permissions, batchCreateElements } =
    useContext(SubItemsContext);
  const [addOpen, setAddOpen] = useState<boolean>(false);

  return (
    <div className={classes.elementsHeader}>
      <div className={classes.elementsHeaderLabel}>Sub Items</div>
      {permissions.canUpdate && (
        <div className={classes.elementsHeaderIcon}>
          <IconButton
            onClick={() => setAddOpen(true)}
            data-cy="addSubItemsButton"
          >
            <Icon icon={AddIcon} />
          </IconButton>
          <AddElementsModal
            open={addOpen}
            onClose={() => setAddOpen(false)}
            assetId={rootAsset.id}
            assetName={rootAsset.name}
            schemaId={rootAsset.schemaId}
            onBatchCreate={batchCreateElements}
            confirmDataCy="addElementModalConfirmButton"
            cancelDataCy="addElementModalCancelButton"
          />
        </div>
      )}
    </div>
  );
};

export default SubItemsHeader;
